import { useFormContext, useWatch } from 'react-hook-form';
import {
  FormStepButtonBack,
  FormStepButtonClose,
  FormStepButtonConfirm,
  FormStepButtonNext,
} from '../../Utils';
import {
  ROUTE_HOMEPAGE,
  ROUTE_PUBLIC_HOMEPAGE,
} from '../../../../constants/urlConstants';
import styles from './FormIncidentNotification.module.scss';
import { useTranslation as t } from '../../../../hooks/useTranslation';
import { useTranslationStore } from '../../../../stores';
import { EpLoading } from '../../../../components/EpLoading';
import { EpButton } from '../../components';
export default function FooterIncidentNotification({
  isPublicTemplate = false,
  isLoading = false,
}: {
  isPublicTemplate?: boolean;
  isLoading?: boolean;
}) {
  const { getValues } = useFormContext();
  const { translations } = useTranslationStore();
  const [activeStep, totalSteps] = getValues([
    'formUtils.activeStep',
    'formUtils.totalSteps',
  ]);
  const [term] = useWatch({ name: ['responsabilityTerm'] });
  const URL_BUTTON_CLOSE_MODAL = isPublicTemplate
    ? ROUTE_PUBLIC_HOMEPAGE
    : ROUTE_HOMEPAGE;

  // useEffect(() => {
  //   console.info(`🚀 ~ values.questions:`, values.questions);
  // }, [values.questions]);

  if (activeStep > totalSteps) {
    return null;
  }

  return (
    <>
      <FormStepButtonClose closeNotificationRoute={URL_BUTTON_CLOSE_MODAL} />

      <div className={styles['footer__btn-group']}>
        <FormStepButtonBack />

        <FormStepButtonConfirm />

        <FormStepButtonNext />
      </div>

      {activeStep === totalSteps &&
        (!isLoading ? (
          <EpButton
            buttonSize="md"
            buttonText={t(translations['global'], 'Send notification')}
            buttonType="primary"
            buttonActionType="submit"
            buttonId={'ep-button__subtmit-form--notification'}
            buttonIsDisabled={!term}
          />
        ) : (
          <div>
            <EpLoading
              position={'relative'}
              loadingType="card"
              loadingId={'loading--page'}
              isVisible
              size="sm"
            />
          </div>
        ))}
    </>
  );
}
